export default __webpack_public_path__ + "images/LS.556d5d8.png";